import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingBag, Tag, Users, Mail, FileText, Settings, LogOut, ExternalLink } from "lucide-react";
import { apiMe, authToken } from "../lib/api";
import Logo from "../components/Logo";

const AdminLayout = () => {
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!authToken.get()) { navigate("/admin/login"); return; }
    apiMe()
      .then((u) => { setEmail(u.email); setLoading(false); })
      .catch(() => { authToken.clear(); navigate("/admin/login"); });
  }, [navigate]);

  const logout = () => { authToken.clear(); navigate("/admin/login"); };

  if (loading) return <div className="p-10 text-sm text-gray-500">Loading admin…</div>;

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 text-[13px] font-medium tracking-wide transition-colors ${
      isActive ? "bg-white text-[#0a0a0a] border-l-2 border-[#b91c1c]" : "text-gray-400 hover:text-white border-l-2 border-transparent"
    }`;

  return (
    <div className="min-h-screen flex bg-[#fafbfc]">
      <aside className="w-64 bg-[#0a0a0a] text-white flex flex-col">
        <div className="p-6 border-b border-white/10">
          <Logo size={56} inverted />
          <div className="mt-3 text-[10px] tracking-[0.3em] uppercase text-red-400">Admin Panel</div>
        </div>
        <nav className="flex-1 py-4">
          <NavLink to="/admin" end className={linkClass}><LayoutDashboard className="h-4 w-4" /> Dashboard</NavLink>
          <NavLink to="/admin/products" className={linkClass}><Package className="h-4 w-4" /> Products</NavLink>
          <NavLink to="/admin/orders" className={linkClass}><ShoppingBag className="h-4 w-4" /> Orders</NavLink>
          <NavLink to="/admin/coupons" className={linkClass}><Tag className="h-4 w-4" /> Coupons</NavLink>
          <NavLink to="/admin/subscribers" className={linkClass}><Users className="h-4 w-4" /> Subscribers</NavLink>
          <NavLink to="/admin/contacts" className={linkClass}><Mail className="h-4 w-4" /> Contacts</NavLink>
          <NavLink to="/admin/posts" className={linkClass}><FileText className="h-4 w-4" /> Journal</NavLink>
          <NavLink to="/admin/settings" className={linkClass}><Settings className="h-4 w-4" /> Settings</NavLink>
        </nav>
        <div className="p-4 border-t border-white/10 text-[12px]">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-white mb-3">
            <ExternalLink className="h-3.5 w-3.5" /> View site
          </a>
          <div className="text-gray-500 mb-2 truncate">{email}</div>
          <button onClick={logout} className="flex items-center gap-2 text-red-400 hover:text-red-300">
            <LogOut className="h-3.5 w-3.5" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
